import React, { useRef, useEffect } from 'react'
import { gsap } from 'gsap/dist/gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { useIsMobile, useIsDesktop } from '../../hooks/useIsDesktop'
import { useIsomorphicLayoutEffect } from 'usehooks-ts'

if (typeof window !== 'undefined') {
  // Due to SSR we can only register when we are in the browser
  gsap.registerPlugin(ScrollTrigger)
}

type FadeInProps = {
  children: any
  onMobile?: boolean
  onDesktop?: boolean
}

const FadeIn = (props: FadeInProps) => {
  const fadeInRef = useRef<HTMLDivElement>(null)
  const isMobile = useIsMobile()
  const isDesktop = useIsDesktop()
  const [showOnMobile, setShowOnMobile] = React.useState(false)
  const [showOnDesktop, setShowOnDesktop] = React.useState(true)

  useEffect(() => {
    setShowOnMobile(props.onMobile != false && isMobile)
  }, [isMobile, props.onMobile])

  useEffect(() => {
    setShowOnDesktop(props.onDesktop != false && isDesktop)
  }, [isDesktop, props.onDesktop])

  useIsomorphicLayoutEffect(() => {
    if (fadeInRef && fadeInRef.current) {
      gsap.set(fadeInRef.current, {
        opacity: 0,
        yPercent: 53,
      })
      const t1 = gsap.timeline({
        scrollTrigger: {
          trigger: fadeInRef.current,
          start: 'top 95%',
          end: 'bottom 50%',
          once: true,
        },
      })

      t1.to(fadeInRef.current, {
        yPercent: 0,
        opacity: 1,
        duration: 0.7,
      })
      return () => {
        t1 && t1.kill()
      }
    }
    
  }, [fadeInRef, showOnMobile])

  return (showOnMobile && isMobile) || (showOnDesktop && isDesktop) ? (
    <div ref={fadeInRef}>{props.children}</div>
  ) : (
    <>{props.children}</>
  )
}

export default FadeIn
